import { createSlice } from '@reduxjs/toolkit';
import { ILayoutInitialStateType, IAction } from './type';

const initialState: ILayoutInitialStateType = {
  isSideMenuCollapsed: false,
  isSpinnerVisible: false,
};

const setSideMenuCollapse = (
  state: ILayoutInitialStateType,
  action: IAction<boolean>,
) => {
  state.isSideMenuCollapsed = action.payload;
};

const setSpinner = (
  state: ILayoutInitialStateType,
  action: IAction<boolean>,
) => {
  state.isSpinnerVisible = action.payload;
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: { setSideMenuCollapse, setSpinner },
});

export const layoutActions = layoutSlice.actions;
const layoutReducer = layoutSlice.reducer;
export default layoutReducer;
